export interface IPersonalizationData {
    [name: string]: string|number|boolean|null;
}

export interface IPersonalizationDataItem {
    name: string;
    type: PersonalizationFieldType;
    value: any;
}

export type PersonalizationMap = Map<string, IPersonalizationDataItem>; // field name --> field details

export interface IPersonalizationExpression {
    expression: string; // OrderCount>4
    field: string; // OrderCount
    type: PersonalizationFieldType; // number
    value: string|number|boolean|null; // 4
    operator: string|null; // >
}

export enum ExpressionsOperator {
    None = 'none',
    And = 'and',
    Or = 'or',
}

export interface IPersonalizationItem {
    $element: HTMLElement;
    expressions: IPersonalizationExpression[];
    operator: ExpressionsOperator;
    /*
    <div data-user-prop="OrderCount>4" class="hidden">
			banner for WCA subscribers that made more than 4 orders
		</div>
     */
}

export enum PersonalizationFieldType {
    Null = 'null',
    String = 'string',
    Number = 'number',
    Boolean = 'boolean',
    Other = 'other',
}

/*
<div data-user-banner>
	<!-- AND example -->
	<div data-user-prop="HasActiveWCA=true and OrderCount>4" class="hidden">
			banner for WCA subscribers that made more than 4 orders
	</div>
	<!-- OR example -->
	<div data-user-prop="HadWCA=false or LTV>=50" class="hidden">
		banner for users who "never had WCA" or their "LTV is less than 50"
	</div>
	<!-- Default example -->
	<div data-user-default class="hidden">
			Default banner for users who don't apply to any of the above rules
	</div>
</div>

<!-- example without surrounding div and default-->
<div data-user-prop="persona=wca-active" class="hidden">
	banner for persona WCA Active
</div>

{
    "itemID": 48741,
    "userID": 97105,
    "wcaVisitCount": 214,
    "wcaVisitDayCount": 73,
    "orderCount": 590,
    "pluginCount": 1558,
    "wcaVisitDaysAgo": 34,
    "WCAChurnScore": 34,
    "userCreatedDaysAgo": 3104,
    "lastOrderDaysAgo": 3,
    "hadWCA": true,
    "hasActiveWCA": true,
    "hasFreePack": true,
    "hasSBSPaymentIssue": true,
    "persona": "wca-active",
    "ltv": 13905.58,
    "cacheVersion": 109
}
 */